var _feGaussianBlur;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShapeDiamondSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 144,
    viewBox: "0 0 38.1 38.100001",
    id: "svg17343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs17337"
  }, /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter24680",
    x: -0.096000001,
    width: 1.192,
    y: -0.096000001,
    height: 1.192
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0583333,
    id: "feGaussianBlur24682"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-258.89998)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "#0073cf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19401787,
      strokeOpacity: 1,
      filter: "url(#filter24680)"
    },
    id: "rect4518-85-9-8-83",
    width: 18.708866,
    height: 18.708866,
    x: 200.65627,
    y: 181.94742,
    transform: "matrix(0.85422302,0.85422295,-0.85422295,0.85422301,3.0684591,-64.860422)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShapeDiamondSelect);
export default __webpack_public_path__ + "static/media/icon-shape-diamond-select.5280e69aa75571f7530eb1bbb569cdc2.svg";
export { ForwardRef as ReactComponent };